import { Link } from "react-router-dom";
import { CalendarDays, ArrowUpRight } from "lucide-react";
import { Contact } from "@/components/site/Contact";
import { ContactForm } from "@/components/site/ContactForm";
import { Reveal } from "@/components/site/Reveal";

export default function ContactPage() {
  return (
    <div className="pt-24 md:pt-28">
      <Contact />

      <section className="relative py-10">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>
            <Link
              to="/book-a-call"
              data-testid="contact-book-call-banner"
              className="group flex items-center justify-between gap-4 rounded-3xl border border-[#bf953f]/30 bg-gradient-to-r from-[#12284a] to-[#0a192f] p-6 md:p-8 hover:border-[#d4af37]/60 transition-colors duration-500"
            >
              <div className="flex items-center gap-4">
                <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-[#bf953f]/30 text-[#d4af37]">
                  <CalendarDays size={22} strokeWidth={1.5} />
                </span>
                <div>
                  <p className="font-serif-display text-xl md:text-2xl text-white">Skip the back-and-forth — book a call</p>
                  <p className="font-body text-sm text-white/50">Pick a time on our calendar that fits your schedule.</p>
                </div>
              </div>
              <ArrowUpRight size={20} className="shrink-0 text-[#d4af37] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>
      </section>

      <ContactForm />
    </div>
  );
}
